import GraphQLJSON from 'graphql-type-json';

const typeResolvers = {};

const resolvers = {
  JSON: GraphQLJSON,
};

const getSearchResults = (context, globalOutletId, input, pageInput) => {
  return [
    {
      companyId: '470041',
      highlightedName: '<em>Noodles</em>',
      name: 'Noodles',
      type: 'BRAND',
      typeId: '1',
    },
    {
      companyId: '470041',
      highlightedName: '<em>Noodles</em>',
      name: 'Noodles',
      type: 'BRAND',
      typeId: '2',
    },
    {
      companyId: '470041',
      highlightedName: '<em>Noodles</em>',
      name: 'Noodles',
      type: 'BRAND',
      typeId: '3',
    },
    {
      companyId: '470041',
      highlightedName: '<em>Noodles</em>, Pasta, Vermicelli ',
      name: 'Noodles, Pasta, Vermicelli',
      type: 'CATEGORY',
      typeId: '1',
    },
    {
      companyId: '470041',
      highlightedName: '<em>Noodles</em>, Pasta, Vermicelli ',
      name: 'Noodles, Pasta, Vermicelli',
      type: 'CATEGORY',
      typeId: '2',
    },
    {
      companyId: '470041',
      highlightedName: '<em>Noodles</em>, Pasta, Vermicelli ',
      name: 'Noodles, Pasta, Vermicelli',
      type: 'CATEGORY',
      typeId: '3',
    },
    {
      companyId: '470041',
      highlightedName: 'Thai Pad Rice <em>Noodles</em>',
      name: 'Thai Pad Rice Noodles',
      type: 'SKU',
      typeId: '2',
    },
    {
      companyId: '470041',
      highlightedName: 'Rice <em>Noodles</em> - Long Life',
      name: 'Rice Noodles - Long Life',
      type: 'SKU',
      typeId: '3',
    },
    {
      companyId: '470041',
      highlightedName: 'Hakka <em>Noodles</em> - Egg',
      name: 'Hakka Noodles - Egg',
      type: 'SKU',
      typeId: '4',
    },
    {
      companyId: '470041',
      highlightedName: 'Cup <em>Noodles</em> - Spinach',
      name: 'Cup Noodles - Spinach',
      type: 'SKU',
      typeId: '5',
    },
    {
      companyId: '470041',
      highlightedName: 'Cup <em>Noodles</em> - Spinach',
      name: 'Cup Noodles - Spinach',
      type: 'SKU',
      typeId: '6',
    },
    {
      companyId: '470041',
      highlightedName: 'Cup <em>Noodles</em> - Spinach',
      name: 'Cup Noodles - Spinach',
      type: 'SKU',
      typeId: '7',
    },
    {
      companyId: '470041',
      highlightedName: 'Cup <em>Noodles</em> - Spinach',
      name: 'Cup Noodles - Spinach',
      type: 'SKU',
      typeId: '8',
    },
    {
      companyId: '470041',
      highlightedName: 'Cup <em>Noodles</em> - Spinach',
      name: 'Cup Noodles - Spinach',
      type: 'SKU',
      typeId: '9',
    },
    {
      companyId: '470041',
      highlightedName: 'Cup <em>Noodles</em> - Spinach',
      name: 'Cup Noodles - Spinach',
      type: 'SKU',
      typeId: '10',
    },
  ];
};

const updateHistory = (globalOutletId, searchHistoryData) => {
  return ['Pathta', 'Pathati', 'Pathanti', searchHistoryData];
};

const mocks = {
  Query: {
    skuSearch: (_, { context, globalOutletId, input, pageInput }) =>
      getSearchResults(context, globalOutletId, input, pageInput),
  },
  Mutation: {
    updateOutletSearchHistory: (_, { globalOutletId, searchHistoryData }) =>
      updateHistory(globalOutletId, searchHistoryData),
  },
};

export { resolvers, typeResolvers, mocks };
